<template>
    <div>
         <v-data-table
            :key="componentKey"
            :headers="computedHeaders"
            :items="tableItems"
            class="elevation-1"
            :loading="coursesLoadStatus===1"
            :options.sync="tableOptions"
            :server-items-length="options.lineCount"
            hide-default-footer
            must-sort
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Moje grupy</v-toolbar-title>
                
                <v-spacer></v-spacer>
                <v-select
                        v-model="selectedCourse"
                        class="search"
                        :items="availableOtherCourses"
                        label="Wybierz grupę"
                        hide-details
                        dense
                      ></v-select>
                      <v-divider class="mx-4" inset vertical></v-divider>
                      <v-btn
                        :disabled="selectedCourse==0"
                        @click="addTempCourse"
                        x-small
                        class="mb-2 mt-2"
                        color="primary"
                      >
                        dodaj
                </v-btn>
              </v-toolbar>
            </template>

            <template v-slot:item.from="{ item }">
              {{ item.from }} - {{ item.to }}
            </template>

            <template v-slot:item.details="{ item }">
              <v-icon
                        v-if="isTempCourse(item)"
                        size="18"
                        class="ml-1 mb-1 mr-1"
                        color="error"
                      >
                        mdi-timer-outline
                </v-icon>
                <span v-if="isTempCourse(item)">
                    {{_.find(item.users,{'id':user.id}).pivot.valid_from}}
                    <span v-if="_.find(item.users,{'id':user.id}).pivot.valid_from!=_.find(item.users,{'id':user.id}).pivot.valid_to">
                        {{' - ' + _.find(item.users,{'id':user.id}).pivot.valid_to}}
                    </span>
                </span>
            </template>
            
          </v-data-table> 
          <confirm ref="confirm"></confirm>
        </div>
</template>

<script>
  import confirm from '../components/Confirm';
     
  export default {
    components: { confirm },
    data: () => ({
      componentKey:0,
      tableOptions: {},
      selectedCourse:0,
      headers: [
        { text: '',align: 'start',sortable: false,value: 'lp',filterable:false,display:true},
        { text: 'Nazwa', value: 'name',filterable:true,filterColumn:"name",display:true },
        { text: 'Sala', value: 'room',filterable:true,filterColumn:"room",display:true },
        { text: 'Godziny', value: 'from',filterable:true,filterColumn:"from",display:true },
        { text: 'Godziny', value: 'to',filterable:true,filterColumn:"to",display:false },
        { text: 'Dzieci', value: 'children_count',filterable:false,display:true },
        { text: '', value: 'details', sortable: false,filterable:false,display:true },
      ],
    }),
    watch: {
      tableOptions: {
        handler () {
          var currentOptions = {...this.options};
          const { sortBy, sortDesc } = this.tableOptions
        
          //zmiana sortowania
          if (sortBy.length === 1 && sortDesc.length === 1) {
            currentOptions.orderBy = sortBy[0];
            currentOptions.orderDirection = sortDesc[0]?'desc':'asc';
            this.options = currentOptions;
          } 
        },
        deep: true,
      },
    },
    computed: {
      user(){
        return this.$store.getters.getUser;
      },
      lookups(){
        return this.$store.getters.getLookups;
      },
      options:{
        get () {  
          return this.$store.getters.getCourseOptions;
        },
        set (value) {
          this.search='';
          this.$store.dispatch( 'setCourseOptions', {options:value} )
        }
      },
      tableItems(){
        return this.$store.getters.getCourses;
      },
      coursesLoadStatus(){
        return this.$store.getters.getCoursesLoadStatus;
      },
      courseAddStatus(){
        return this.$store.getters.getCourseAddStatus();
      },
      courseAddText(){
        return this.$store.getters.getCourseAddText;
      },
      computedHeaders () {
        var localHeaders = [...this.headers.filter(h => h.display===true)]

        return localHeaders
      },
      availableOtherCourses(){
        return this.lookups.all_courses.filter(u => !_.find(this.lookups.my_courses,{'value':u.value}));
      },
    },
    methods: {
        addTempCourse(){
            this.$refs.confirm.open('Dostęp tymczasowy', 'Czy chcesz aktywować dostęp tymczasowy do wybranej grupy do końca dnia?', { color: 'error' }).then((confirm) => {
                if(confirm){
                    this.$store.dispatch( 'addTempUserToCourse', {slug: this.selectedCourse ,id:  this.user.id});
                }
            })
        },
        isTempCourse(item){
          var u = _.find(item.users,{'id':this.user.id});
          if(u && u.pivot.temp){
            return true;
          }
          return false;
        }
    },
  }
</script>
<style scoped>
.search{
      max-width: 250px;
}
.choose_year{
      max-width: 150px;
}
</style>